import React, { useState } from 'react';
import "./macro.css";
import { useTranslation } from 'react-i18next';
import microdoc from "../files/micro2010.xlsx";

const DocumentIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2c5282" strokeWidth="2" aria-hidden="true">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M16 13H8" />
    <path d="M16 17H8" />
    <path d="M10 9H8" />
  </svg>
);

const MacroEco = () => {
  const { t } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [pinCode, setPinCode] = useState('');
  const [error, setError] = useState('');
  const correctPin = '1234'; // Статический пин-код

  const features = Array.isArray(t('trainingPlan.sections.macroeconomics.content.features', { returnObjects: true }))
    ? t('trainingPlan.sections.macroeconomics.content.features', { returnObjects: true })
    : [];
  const programs = Array.isArray(t('trainingPlan.sections.macroeconomics.content.programs', { returnObjects: true }))
    ? t('trainingPlan.sections.macroeconomics.content.programs', { returnObjects: true })
    : [];
  const links = Array.isArray(t('trainingPlan.sections.documents.links', { returnObjects: true }))
    ? t('trainingPlan.sections.documents.links', { returnObjects: true })
    : [];

  const handleDownloadClick = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
  };

  const handlePinSubmit = (e) => {
    e.preventDefault();
    if (pinCode === correctPin) {
      setError('');
      setIsPopupOpen(false);
      setPinCode('');
      const link = document.createElement('a');
      link.href = microdoc;
      link.download = '';
      link.click();
    } else {
      setError(t('trainingPlan.sections.documents.invalidPin'));
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPinCode('');
    setError('');
  };

  return (
    <div className="training-plan">
      <div className="training-item">
        <h2 className="training-item__title">{t('trainingPlan.sections.macroeconomics.title')}</h2>
        <div className="training-item__content">
          <p>{t('trainingPlan.sections.macroeconomics.content.intro')}</p>
          <p>{t('community')}</p>
          <ul>
            {features.map((feature, index) => (
              <li key={`feature-${index}`}>{feature}</li>
            ))}
          </ul>
          <p>{t('trainingPlan.sections.macroeconomics.content.programsTitle')}</p>
          <ul>
            {programs.map((program, index) => (
              <li key={`program-${index}`}>{program}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="training-item">
        <h2 className="training-item__title">{t('trainingPlan.sections.documents.title')}</h2>
        <div className="training-item__content">
          {links.map((link, index) => (
            <a
              href={microdoc}
              className="download-link"
              key={`link-${index}`}
              onClick={handleDownloadClick}
              aria-label={t('trainingPlan.sections.documents.downloadAria', { label: link.label })}
            >
              <span className="download-link__icon">
                <DocumentIcon />
              </span>
              {link.label}
            </a>
          ))}
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup">
            <h3>{t('trainingPlan.sections.documents.popupTitle')}</h3>
            <form onSubmit={handlePinSubmit}>
              <label htmlFor="pinCode">{t('trainingPlan.sections.documents.pinLabel')}</label>
              <input
                type="password"
                id="pinCode"
                value={pinCode}
                onChange={(e) => setPinCode(e.target.value)}
                placeholder={t('trainingPlan.sections.documents.pinPlaceholder')}
                autoFocus
                aria-invalid={error ? 'true' : 'false'}
                aria-describedby={error ? 'pin-error' : undefined}
              />
              {error && (
                <p id="pin-error" className="error">
                  {error}
                </p>
              )}
              <div className="popup-actions">
                <button type="submit">{t('trainingPlan.sections.documents.submitButton')}</button>
                <button type="button" onClick={handleClosePopup}>
                  {t('trainingPlan.sections.documents.cancelButton')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(MacroEco);